import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import useAuth from "../../hooks/useAuth";
import { BASE_URL } from "../../utils/Element";
import Modal from "../Modal/Modal";

const RemoveLeadSourceModal = ({
  showModal,
  onClose,
  onSuccess,
  selectedItem,
}) => {
  const [config] = useAuth();

  const [error, setError] = useState(null);
  const [leadSourcesOptions, setLeadSourcesOptions] = useState([]);
  const [selectedValues, setSelectedValues] = useState({
    lead_source: null,
  });

  // ✅ Close handler
  const handleClose = () => {
    setError(null);
    setSelectedValues({ lead_source: null });
    onClose();
  };

  // ✅ Confirm handler
  const handleConfirm = (e) => {
    e.preventDefault();

    const leadSourceId = selectedValues?.lead_source;

    if (!leadSourceId) {
      setError("Please select a lead source.");
      return;
    }

    // ✅ Safe handling of selectedItem
    const contactIds = Array.isArray(selectedItem)
      ? selectedItem.map((item) => item?.id).filter(Boolean)
      : selectedItem?.id
      ? [selectedItem.id]
      : [];

    if (!contactIds.length) {
      setError("No valid contact selected.");
      return;
    }

    const dataToSend = {
      action: "removeleadsource",
      contact_id: contactIds,
      leadsourceid: leadSourceId,
    };

    axios
      .post(
        `${BASE_URL}/remove-lead-source-from-contact/${leadSourceId}`,
        dataToSend,
        config
      )
      .then(() => {
        onSuccess();
        handleClose();
      })
      .catch((error) => {
        console.error("Error removing lead source:", error);
        setError(error.response?.data?.message || "An error occurred.");
      });
  };

  // ✅ Fetch lead sources
  const fetchLeadSources = () => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=lead_sources`, config)
      .then((res) => {
        const value = res?.data?.data?.lead_sources || [];

        const formattedOptions = value.map((el) => ({
          value: el?.id,
          label: el?.name,
          category: el?.category,
        }));

        setLeadSourcesOptions(formattedOptions);
      })
      .catch((err) => {
        const message = err.response?.data?.message;

        if (message && message !== "Too Many Attempts.") {
          NotificationManager.error(message);
        }
      });
  };

  useEffect(() => {
    if (showModal) {
      fetchLeadSources();
    }
  }, [showModal]);

  return (
    <Modal width="500px" show={showModal} onClose={handleClose}>
      <form onSubmit={handleConfirm}>
        <div className="flex-1 w-30">
          <p className="head-1 dark-H font-bold text-center">
            Remove Lead Source
          </p>

          <p className="py-1 dark-M body-L text-center">
            Are you sure you want to remove the Lead Source?
          </p>

          <div className="mt-4">
            <label className="dark-H head-4 mb-2">
              Lead Source<span className="red-D">*</span>
            </label>

            <Select
              className="service-area body-L dark-M"
              options={[
                { label: "None", value: null },
                ...leadSourcesOptions,
              ]}
              placeholder="Select"
              value={
                leadSourcesOptions.find(
                  (option) =>
                    option.value === selectedValues.lead_source
                ) || null
              }
              onChange={(option) => {
                setSelectedValues((prev) => ({
                  ...prev,
                  lead_source: option?.value || null,
                }));
              }}
              isClearable
            />
          </div>
        </div>

        <div className="mt-6 mb-6 flex justify-center">
          <button
            type="submit"
            className="save-button light-L head-5 green-bg-H px-[30px] py-[12px]"
          >
            Remove
          </button>
          <button
            type="button"
            onClick={handleClose}
            className="green-H body-N ml-5"
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default RemoveLeadSourceModal;
